import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import numericInputHelper from '../../util/numericInputHelpers';
import UNITS from '../../common/numericInputUnits';
import inputClassFactory from '../textInput/inputClassFactory';
import textInputTemplate from '../textInput/textInput.jsx';
var textInput = compose(inputClassFactory(displayNames.TEXT_INPUT, textInputTemplate));
import Button from '../button/button';
import TriangleDown from './triangleDown.svg.js';
import TriangleUp from './triangleUp.svg.js';
import withValidation from '../../hoc/withValidation';
var UP = 38;
var DOWN = 40;
var MAXIMUM_FRACTION_DIGITS = 21;

var ALLOWED_FRACTION_DIGIT_NUMBERS = _.range(MAXIMUM_FRACTION_DIGITS);

var getNumber = function getNumber(value) {
  var isNumber = /^-?\d*\.?\d*$/.test(value);
  return isNumber ? Number(value) : null;
};

var NumericInput = /*#__PURE__*/function (_React$Component) {
  _inherits(NumericInput, _React$Component);

  var _super = _createSuper(NumericInput);

  function NumericInput(props) {
    var _this;

    _classCallCheck(this, NumericInput);

    _this = _super.call(this, props);

    _this.getValidValue = function (value) {
      var _this$props = _this.props,
          prevValue = _this$props.value,
          shouldRoundByStep = _this$props.shouldRoundByStep,
          step = _this$props.step,
          min = _this$props.min,
          max = _this$props.max,
          fractionDigits = _this$props.fractionDigits;
      return numericInputHelper.getValidNumericValue(value, prevValue, min, max, shouldRoundByStep, step, fractionDigits);
    };

    _this.state = {
      rawValue: isNaN(_this.props.value) && _this.props.placeholder ? undefined : String(props.value),
      showTooltip: false,
      focused: false
    };

    _this.handleChange = function (newValueAsString) {
      if (newValueAsString === _this.state.rawValue) {
        return;
      }

      var newValue = getNumber(newValueAsString);

      if (_.isNull(newValue)) {
        _this.setState({
          showTooltip: true
        });

        return;
      }

      var isTempValue = isNaN(newValue) || newValue < _this.props.min || _this.props.max < newValue;

      _this.setState({
        rawValue: newValueAsString,
        showTooltip: false
      }, isTempValue ? _.noop : _.partial(_this.props.onChange, newValue));
    };

    _this.handleFocus = function (e, isCanceled) {
      if (_this.props.onFocus) {
        _this.props.onFocus(e, isCanceled);
      }

      _this.setState({
        focused: true
      });
    };

    _this.handleBlur = function (e, isCanceled) {
      if (!isCanceled) {
        var valueNumber = Number(_this.state.rawValue);

        var fixedValue = _this.getValidValue(valueNumber);

        _this.handleChange(fixedValue);
      }

      _this.props.onBlur(e, isCanceled);

      _this.setState({
        focused: false
      });
    };

    _this.handleKeyDown = function (_ref) {
      var keyCode = _ref.keyCode;

      if (!_.includes([UP, DOWN], keyCode)) {
        return;
      }

      if (keyCode === UP) {
        _this.increment();
      } else {
        _this.decrement();
      }
    };

    _this.getTooltipProps = function () {
      return {
        isOpen: _this.state.showTooltip,
        content: _this.props.numbersOnlyMessage,
        openOnMouseEnter: false,
        closeOnMouseLeave: false,
        shouldTranslate: _this.props.shouldTranslate,
        onScroll: function onScroll() {
          _this.setState({
            showTooltip: false
          });
        }
      };
    };

    _this.increment = function () {
      if (_this.props.step) {
        var nextValue = _this.getValidValue(Number(_this.state.rawValue) + _this.props.step);

        _this.handleChange(nextValue);

        var onIncrement = _this.props.onIncrement;

        if (onIncrement) {
          onIncrement(nextValue);
        }
      }
    };

    _this.decrement = function () {
      if (_this.props.step) {
        var nextValue = _this.getValidValue(Number(_this.state.rawValue) - _this.props.step);

        _this.handleChange(nextValue);

        var onDecrement = _this.props.onDecrement;

        if (onDecrement) {
          onDecrement(nextValue);
        }
      }
    };

    return _this;
  }

  _createClass(NumericInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.handleChange(String(nextProps.value));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (isNaN(this.props.value) && this.props.placeholder) {
        this.setState({
          rawValue: undefined
        });
      } else {
        this.handleChange(this.getValidValue(this.props.value));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var stepControls = this.props.stepControls;
      var focused = this.state.focused;
      var defaultNumericInput = /*#__PURE__*/React.createElement(textInput, _.assign({}, this.props, {
        showInfoTooltip: !_.isEmpty(this.props.numbersOnlyMessage),
        infoTooltipProps: this.getTooltipProps(),
        className: this.props.getClassName('control-numeric-input' + (this.state.showTooltip ? ' invalid' : '')),
        value: this.state.rawValue,
        onChange: this.handleChange,
        inputTextSuffix: UNITS[this.props.unit] || this.props.unit,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        shouldTranslate: false,
        shouldTranslateError: this.props.shouldTranslate
      }, _.isUndefined(this.props.successValue) ? {} : {
        successValue: String(this.props.successValue)
      }));

      var _renderStepControls = function _renderStepControls() {
        var _this2$props = _this2.props,
            inputHeight = _this2$props.inputHeight,
            disabled = _this2$props.disabled;
        return /*#__PURE__*/React.createElement("div", {
          className: "step-control-wrapper ".concat(inputHeight)
        }, defaultNumericInput, !focused && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
          className: "step-up",
          onClick: _this2.increment,
          disabled: disabled
        }, /*#__PURE__*/React.createElement(TriangleUp, {
          key: "triangle-up"
        })), /*#__PURE__*/React.createElement(Button, {
          className: "step-down",
          onClick: _this2.decrement,
          disabled: disabled
        }, /*#__PURE__*/React.createElement(TriangleDown, {
          key: "triangle-down"
        }))));
      };

      return stepControls ? _renderStepControls() : defaultNumericInput;
    }
  }]);

  return NumericInput;
}(React.Component);

NumericInput.displayName = 'NumericInput';
NumericInput.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  prefix: PropTypes.string,
  innerInputClass: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onIncrement: PropTypes.func,
  onDecrement: PropTypes.func,
  focus: PropTypes.bool,
  onClick: PropTypes.func,
  focusOnPrefixClick: PropTypes.bool,
  shouldRoundByStep: PropTypes.bool,
  fractionDigits: PropTypes.oneOf(ALLOWED_FRACTION_DIGIT_NUMBERS),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  stepControls: PropTypes.bool,

  /** Units: percent, px, angle, seconds. or any string */
  unit: PropTypes.oneOfType([PropTypes.oneOf(['percent', 'px', 'angle', 'seconds']), PropTypes.string]),
  numbersOnlyMessage: PropTypes.string,

  /** Placeholder to show when no value is entered */
  placeholder: PropTypes.string.isRequired,

  /** Renders an <InfoIcon/> */
  infoIcon: PropTypes.object
};
NumericInput.defaultProps = {
  onChange: _.noop,
  onBlur: _.noop,
  focusOnPrefixClick: true,
  shouldRoundByStep: true,
  fractionDigits: 2,
  min: 0,
  max: 100,
  step: 1
};
export default compose(NumericInput, [withValidation]);